import React from 'react';

import styled from 'styled-components';

import { COLORS } from '../../../utils/theme/colors';
import Polygon from '../../atoms/icons/Polygon';

export const HeaderIcon2 = ({type}) => {
    const renderIcon = () => {
        switch(type) {
            case 'desc':
                return (
                    <Polygon className="desc" />
                );
            case 'asc':
                return (
                    <Polygon className="asc" />
                );
            default:
                return (
                    <p className="no_order">-</p>
                );
         }
    };

    return (
        <Div className="header_icon_gabrr">
            {renderIcon()}
        </Div>
    ); 
};

const Div = styled.div`
    transition: 200ms ease-in-out;
    top: 50%;
    display: flex;
    transform-origin: center;
    position: absolute;
    right: 10px;
    fill: ${COLORS.primary};
    
    .desc {
        transform: rotate(-180deg) translateY(50%);
    }

    .asc {
        transform: rotate(0deg) translateY(-50%);
    }

    .no_order {
        font-size: 30px;
        transform: translateY(-50%);
        color: ${COLORS.lightDarkText};
    }
`;